import { render, staticRenderFns } from "./acceptInvite.vue?vue&type=template&id=8529bd66&scoped=true&"
import script from "./acceptInvite.vue?vue&type=script&lang=js&"
export * from "./acceptInvite.vue?vue&type=script&lang=js&"
import style0 from "./acceptInvite.vue?vue&type=style&index=0&id=8529bd66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8529bd66",
  null
  
)

export default component.exports